import { Injectable } from '@angular/core';
import { pad } from 'lodash-es';
import moment from 'moment';

import { BridgeService } from './BridgeService';

export interface AprimaAnalyticsTiming {
  stop(): void;
}

@Injectable({
  providedIn: 'root',
})
export class AprimaAnalyticsService {
  static readonly ajsFactoryName = 'AprimaAnalytics';

  constructor(
    private readonly bridge: BridgeService,
  ) {
  }

  private queueOperation(fn: () => void) {
    setTimeout(fn, 0);
  }

  sendEvent(category: string, action: string, label: string, value?: string) {
    const sendEventCallback = () => {
      // eslint-disable-next-line no-console
      console.debug('Event: ' + pad(category, 20) + ' | ' + pad(action, 20) + ' | ' + pad(label, 20) + ' | ' + pad(value, 20));
      this.bridge.fireEvent('trackEvent', {
        category: category || '',
        action: action || '',
        label: label || '',
        value: value || '',
      });
    };
    this.queueOperation(sendEventCallback);
  }

  sendPageView(location: string) {
    const sendPageViewCallback = () => {
      // eslint-disable-next-line no-console
      console.debug('Page Change: ' + pad(location, 30));
      this.bridge.fireEvent('trackPageChange', {
        page: location,
      });
    };
    this.queueOperation(sendPageViewCallback);
  }

  sendException(message: string) {
    const sendExceptionCallback = () => {
      // eslint-disable-next-line no-console
      console.debug('Exception: ' + message);
      this.bridge.fireEvent('trackException', {
        message,
      });
    };
    this.queueOperation(sendExceptionCallback);
  }

  startTiming(page: string, category: string, label: string): AprimaAnalyticsTiming {
    const startTime = new Date().getTime();

    return {
      stop: () => {
        const endTime = new Date().getTime();
        setTimeout(() => {
          this.stopTiming(page, category, label, startTime, endTime);
        }, 0);
      },
    };
  }

  private stopTiming(page: string, category: string, label: string, startTime: number, endTime: number): void {
    const elapsedTime = moment(endTime).diff(moment(startTime), 'millisecond');
    const timingValue = elapsedTime.toString();

    // eslint-disable-next-line no-console
    console.debug('Timing: ' + pad(page, 30) + ' | ' + pad(category, 7) + ' | ' + pad(label, 30) + ' | ' + pad(timingValue, 5) + 'ms');
    this.bridge.fireEvent('trackTiming', {
      category: category || '',
      label: label || '',
      value: timingValue || '',
      page: page || '',
    });
  }
}
